import http from '~/common/http'
export default {
    getList(params, action) {
        return http.get('/api/payment-count/' + action, {
            params: params
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/PaymentCount.js